<template>
  <div class="col-sm-12" v-if="summary.Total.count >= 1">
    <div class="row totrow">
      <div class="col tot">
        <div class="row">
          <!-- <div class="col-sm-12 lbl" 
          @click="getDetail('total')" -->
          <div class="col-sm-12 lbl" 
          >
            Total Calls
            <div class="col-sm-12 cnt">
              <countTo
                :startVal="startVal"
                :endVal="summary.Total.count"
                :duration="3000"
                >{{summary.Total.count}}</countTo
              >
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="col tot" 
      @click="getDetail('air')"> -->
      <div class="col tot">
        <div class="row">
          <div class="col-sm-12 lbl">Air</div>
          <div class="col-sm-12 cnt">
            <countTo
              :startVal="startVal"
              :endVal="summary.Air.count"
              :duration="3000"
              >{{ summary.Air.count }}</countTo
            >
          </div>
        </div>
      </div>
      <!-- <div class="col tot" 
      @click="getDetail('pollen')"> -->
      <div class="col tot">
        <div class="row">
          <div class="col-sm-12 lbl">Pollen</div>
          <div class="col-sm-12 cnt">
            <countTo
              :startVal="startVal"
              :endVal="summary.Pollen.count"
              :duration="3000"
              >{{ summary.Pollen.count }}</countTo
            >
          </div>
        </div>
      </div>
      <!-- <div class="col tot" @click="getDetail('weather')"> -->
        <div class="col tot">
        <div class="row">
          <div class="col-sm-12 lbl">Weather</div>
          <div class="col-sm-12 cnt">
            <countTo
              :startVal="startVal"
              :endVal="summary.Weather.count"
              :duration="1000"
              >{{summary.Weather.count}}</countTo
            >
          </div>
        </div>
      </div>
      <!-- <div class="col tot" @click="getDetail('soil')"> -->
        <div class="col tot">
        <div class="row">
          <div class="col-sm-12 lbl">Soil</div>
          <div class="col-sm-12 cnt">
            <countTo
              :startVal="startVal"
              :endVal="summary.Soil.count"
              :duration="3000"
              >{{ summary.Soil.count }}</countTo
            >
          </div>
        </div>
      </div>
      <!-- <div class="col tot" @click="getDetail('water')"> -->
        <div class="col tot">
        <div class="row">
          <div class="col-sm-12 lbl">Water</div>
          <div class="col-sm-12 cnt">
            <countTo
              :startVal="startVal"
              :endVal="summary.Water_Vapour.count"
              :duration="3000"
              >{{ summary.Water_Vapour.count }}</countTo
            >
          </div>
        </div>
      </div>
      <!-- <div class="col tot" @click="getDetail('fire')"> -->
      <div class="col tot">
        <div class="row">
          <div class="col-sm-12 lbl">Fire</div>
          <div class="col-sm-12 cnt">
            <countTo
              :startVal="startVal"
              :endVal="summary.Fire.count"
              :duration="3000"
              >{{ summary.Fire.count }}</countTo
            >
          </div>
        </div>
      </div>
      <!-- <div class="col tot" @click="getDetail('all')"> -->
      <div class="col tot">
        <div class="row">
          <div class="col-sm-12 lbl">All</div>
          <div class="col-sm-12 cnt">
            <countTo
              :startVal="startVal"
              :endVal="summary.All.count"
              :duration="3000"
              >{{ summary.All.count }}</countTo
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import countTo from "vue-count-to";

export default {
  data() {
    return {
      summary: {},
      startVal: 0,
      endVal: 0,
      filterObj: {},
    };
  },
  props: ["start", "end", "day", "userTrans"],
  components: {
    countTo,
  },
  methods: {
    async totUsage() {
      // const apiUri = `http://localhost:3002/dashboard/total?start=${this.start}&end=${this.end}`;
      const apiUri = `http://13.235.254.91:5000/dashboard/total?start=${this.start}&end=${this.end}`;
      const options = {
        url: apiUri,
        method: "GET",
      };
      await this.$http(options)
        .then((result) => {
          this.summary = result.data;
        })
        .catch((e) => console.log("came to error", e));
    },
    userSummary(data) {
      this.summary = data;
    },
    getDetail(param) {
      this.filterObj = {
        custom: true,
        days:
          this.day === "today"
            ? 1
            : this.day === "this week"
            ? 7
            : this.day === "this month"
            ? 30
            : 0,
        from: this.start,
        to: this.end,
      };
      this.$router.push({
        path: `/apiusers?type=${param}`,
        query: this.filterObj,
      });
    },
    async stats() {},
  },
  watch: {
    start: {
      immediate: true,
      handler(v) {
        if (v) this.totUsage();
      },
    },
    end:
    {
      immediate: true,
      handler(v) {
        if (v) this.totUsage();
      }
    },
    userTrans: {
      immediate: true,
      handler(v) {
        if (v) this.userSummary(v);
      },
    },
  },
};
</script>

<style scoped>
.totrow {
  display: inline-flex;
}
.cnt {
  font-size: 2rem;
}
.lbl {
  padding-top: 1.3rem;
  font-size: 0.9rem;
}
.tot {
  margin: 0.2rem;
  height: 6rem;
  color: white;
  text-align: center;
  /* cursor: pointer; */
}
.tot:hover {
  font-size: 1.5rem;
}
.tot:nth-child(1) {
  color: #e91e63;
}
.tot:nth-child(2) {
  color: #3f51b5;
}
.tot:nth-child(3) {
  color: #28a745;
}
.tot:nth-child(4) {
  color: #a13764;
}
.tot:nth-child(5) {
  color: #743d2b;
}
.tot:nth-child(6) {
  color: #2295c8;
}
.tot:nth-child(7) {
  color: #ffb347;
}
.tot:nth-child(8) {
  color: #b2ad7f;
}
</style>